import { render, staticRenderFns } from "./CustomerBook.vue?vue&type=template&id=7804a142"
import script from "./CustomerBook.vue?vue&type=script&lang=js"
export * from "./CustomerBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports